<template>
  <div class="grid-view" type="primary">
    <div class="main-content">
      <div class="section operations" style="height: 39px;">
        <div class="triggers" style="margin-top: 7px;">
          <div>
            <span style="display: inline-block;width: 140px;color: #333333;padding-left: 30px;vertical-align: middle;">{{ $t('CargoMsg.Cargo_ShippingCompanyName') }}</span>
            <el-input
              v-model="shipCompanyInfo.shipCompanyName"
              no="shipCompanyName"
              style="width: 200px"
              size="mini"
              @change="shipCompanyInfo.pageNum=1"
              @keyup.enter.native.prevent="fetchShipCompanyList"
            />
            <span style="display: inline-block;width: 100px;color: #333333;padding-left: 30px;vertical-align: middle;">{{ $t('CargoMsg.Cargo_ShippingCompanyCode') }}</span>
            <el-input
              v-model="shipCompanyInfo.shipCompanyCode"
              no="shipCompanyCode"
              style="width: 200px"
              size="mini"
              @change="shipCompanyInfo.pageNum=1"
              @keyup.enter.native.prevent="fetchShipCompanyList"
            />
            <span style="display: inline-block;width: 150px;color: #333333;padding-left: 30px;vertical-align: middle;">{{ $t('CargoMsg.Cargo_ShippingCompanyScacCode') }}</span>
            <el-input
              v-model="shipCompanyInfo.shipCompanyScacCode"
              no="shipCompanyScacCode"
              style="width: 200px"
              size="mini"
              @change="shipCompanyInfo.pageNum=1"
              @keyup.enter.native.prevent="fetchShipCompanyList"
            />
            <el-button no="toQuery" size="mini" type="primary" @click="fetchShipCompanyList">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
            <el-button
              no="query"
              size="mini"
              type="primary"
              @click="shipCompanyAdd(true)"
            >{{ $t('CargoMsg.Cargo_NewTo') }}</el-button>
            <el-button
              no="editTo"
              size="mini"
              type="primary"
              @click="shipCompanyAdd(false)"
            >{{ $t('CargoMsg.Cargo_EditTo') }}</el-button>
            <el-button
              no="delete"
              size="mini"
              type="danger"
              @click="toBatchDelShipCompany"
            >{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          </div>
        </div>
      </div>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid
          no="100002-grid"
          config-module="100002"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="shipCompanyInfo.total>0"
          no="1000044-pagination"
          config-module="1000044"
          :total="shipCompanyInfo.total"
          :page.sync="shipCompanyInfo.pageNum"
          :limit.sync="shipCompanyInfo.pageSize"
          @pagination="fetchShipCompanyList"
        />
      </div>
    </div>

    <el-dialog
      v-el-drag-dialog
      :visible.sync="shipCompanyAddDialog.isShow"
      :title="shipCompanyAddDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="150px" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_ShippingCompanyChineseName')">
            <el-input v-model="shipCompanyAddDialog.data.shipCompanyChineseName" />
          </el-form-item>
          <el-form-item label-width="150px" required :label="$t('CargoMsg.Cargo_ShippingCompanyEnglishName')">
            <el-input v-model="shipCompanyAddDialog.data.shipCompanyEnglishName" style="width:100%;" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ShippingCompanyCode')">
            <el-input v-model="shipCompanyAddDialog.data.shipCompanyCode" style="width:100%;" />
          </el-form-item>
          <el-form-item label="AMS_SCAC CODE">
            <el-input v-model="shipCompanyAddDialog.data.amsScacCode" style="width:100%;" />
          </el-form-item>
          <el-form-item label="eManifest_SCAC CODE">
            <el-input v-model="shipCompanyAddDialog.data.emanifestScacCode" style="width:100%;" />
          </el-form-item>
          <el-form-item label="AFR_SCAC CODE">
            <el-input v-model="shipCompanyAddDialog.data.afrScacCode" style="width:100%;" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_YdShipCode')">
            <el-input v-model="shipCompanyAddDialog.data.ydCode" style="width:100%;" />
          </el-form-item>
          <el-form-item label="EORI">
            <so-no-input v-model="shipCompanyAddDialog.data.carrierEori" title="EORI " style="width:100%;" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="shipCompanyAddDialog.isAdd ? toAdd():editSeaPort()">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="shipCompanyAddDialog.isShow=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { getGridSelected } from '@/utils/agGrid'
import { getLoading } from '@/utils/utilBaseElement'
import { addShipCompany, deleteShipCompany, shipCompanySelectPage, updateShipCompany } from '@/api/partner/shipping'
import soNoInput from '@/components/Cargo/Job/soNoInput'

export default {
  name: 'ShippingCompany',
  components: { soNoInput },
  data() {
    return {
      fullscreenLoading: null,
      shipCompanyAddDialog: {
        isShow: false,
        data: {},
        title: this.$t('CargoMsg.Cargo_NewTo'),
        isAdd: true
      },
      shipCompanyInfo: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 10,
        shipCompanyName: '', // 船公司名称
        shipCompanyCode: '', // 船公司代码
        shipCompanyScacCode: '' // 船公司SCAC CODE
      },
      gridOptions: {
        rowClassRules: {
          'grid-row-zebra-even': function(params) {
            return !(params.rowIndex % 2)
          },
          'grid-row-zebra-odd': function(params) {
            return (params.rowIndex % 2)
          }
        },
        rowSelection: 'multiple',
        suppressRowClickSelection: true
      },
      gridParams: {},
      rowData: []
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ShippingCompanyChineseName'),
          field: 'shipCompanyChineseName',
          width: 250
        }, {
          headerName: this.$t('CargoMsg.Cargo_ShippingCompanyEnglishName'),
          field: 'shipCompanyEnglishName',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ShippingCompanyCode'),
          field: 'shipCompanyCode',
          width: 150
        }, {
          headerName: 'AMS_SCAC CODE',
          field: 'amsScacCode',
          width: 150
        }, {
          headerName: 'eManifest_SCAC CODE',
          field: 'emanifestScacCode',
          width: 150
        }, {
          headerName: 'AFR_SCAC CODE',
          field: 'afrScacCode',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_YdShipCode'),
          field: 'ydCode',
          width: 150
        }, {
          headerName: 'EORI',
          field: 'carrierEori',
          width: 150
        }
      ]
    }
  },
  mounted() {
    this.fetchShipCompanyList(true)
  },
  methods: {
    fetchShipCompanyList(forbidLoading = false) {
      if (!forbidLoading) {
        this.fullscreenLoading = getLoading()
      }
      Promise.all([shipCompanySelectPage({ ...this.shipCompanyInfo })]).then(results => {
        const shipCompany = results[0]
        this.shipCompanyInfo.pageNum = shipCompany.data.pageNum
        this.shipCompanyInfo.pageSize = shipCompany.data.pageSize
        this.shipCompanyInfo.total = Number(shipCompany.data.total)
        this.rowData = [...shipCompany.data.list]
      }).finally(() => {
        if (!forbidLoading) {
          this.fullscreenLoading.close()
        }
      })
    },
    toBatchDelShipCompany() {
      if (!this.isSelect()) {
        return
      }
      const self = this

      this.$confirm(this.$t('CargoMsg.Cargo_DeleteShipCompany'), this.$t('Message.Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        const chooseRows = getGridSelected(this.gridOptions)
        deleteShipCompany(chooseRows).then(res => {
          if (res.ok) {
            this.$message.success(this.$t('Message.DeleteSucceeded'))
            self.fetchShipCompanyList()
          } else {
            this.$message({
              type: 'info',
              message: this.$t('Message.DeleteFail')
            })
          }
        })
      }).catch(() => {
        this.$message.info(this.$t('Message.DeletionCancelled'))
      })
    },
    // 新增列表弹窗
    shipCompanyAdd(isAdd) {
      this.shipCompanyAddDialog.isAdd = isAdd
      if (isAdd) {
        this.shipCompanyAddDialog.data = {}
        this.shipCompanyAddDialog.title = this.$t('CargoMsg.Cargo_NewTo')
        this.shipCompanyAddDialog.isShow = true
      } else {
        if (!this.isSelect()) {
          return
        }
        this.shipCompanyAddDialog.data = { ...getGridSelected(this.gridOptions)[0] }
        this.shipCompanyAddDialog.title = this.$t('CargoMsg.Cargo_EditTo')
        this.shipCompanyAddDialog.isShow = true
      }
    },
    // 不空校验
    toCheckSeaportForm() {
      const data = this.shipCompanyAddDialog.data
      if (!data.shipCompanyEnglishName) {
        this.$message.error(this.$t('CargoMsg.Cargo_ShippingCompanyEnglishName') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return false
      }
      return true
    },
    // 编辑
    editSeaPort() {
      if (!this.toCheckSeaportForm()) {
        return
      }
      return updateShipCompany(this.shipCompanyAddDialog.data).then(res => {
        if (res.data === -1) {
          this.$message.error(this.$t('CargoMsg.Cargo_DataDuplication'))
        } else {
          this.shipCompanyAddDialog.isShow = false
          this.$message.success(this.$t('Message.EditedSuccessfully'))
          this.fetchShipCompanyList()
        }
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },

    // 添加
    toAdd() {
      if (!this.toCheckSeaportForm()) {
        return
      }
      this.fullscreenLoading = getLoading()
      addShipCompany(this.shipCompanyAddDialog.data).then(res => {
        if (res.data === -1) {
          this.$message.error(this.$t('CargoMsg.Cargo_DataDuplication'))
        } else {
          this.shipCompanyAddDialog.isShow = false
          this.$message.success(this.$t('CargoMsg.Cargo_AddedSuccessfully'))
          this.fetchShipCompanyList()
        }
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    // 是否勾选
    isSelect() {
      const rows = getGridSelected(this.gridOptions)
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return false
      }
      if (rows.length > 1) {
        this.$message.warning(this.$t('common.tips.hasOneOnly'))
        return false
      }
      return true
    }
  }

}
</script>

<style scoped lang="scss">
.add-basic-seaport ::v-deep {
  .ag-paging-page-summary-panel  {
    display: flex;
  }
}
</style>
